import { subscribe } from './event-logger';
import { FACEBOOK_EVENT_TYPES } from './event-types';
import { safeStorage } from './safe-storage';

const FACEBOOK_PIXEL_ID = '455294644042269';

let isInitialized = false;

function initFacebookPixel() {
    if (isInitialized || window.fbq) {
        return;
    }

    isInitialized = true;

    /* eslint-disable */
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq('init', FACEBOOK_PIXEL_ID);
    window.fbq('track', 'PageView');
}

function initFacebookPixelIfConsented() {
    try {
        const quizState = JSON.parse(safeStorage.getItem('quiz_state'));

        if (!quizState || (quizState.currentSlideIndex === 0 && !quizState.finished)) {
            return;
        }
    } catch (e) {
        console.error(e);

        return;
    }

    initFacebookPixel();
}

const facebookTracker = {
    track(event) {
        if (!window.fbq) {
            return;
        }

        window.fbq('track', event);
    }
};

subscribe((eventType) => {
    if (FACEBOOK_EVENT_TYPES.hasOwnProperty(eventType)) {
        facebookTracker.track(FACEBOOK_EVENT_TYPES[eventType]);
    }
});

export {
    facebookTracker,
    initFacebookPixel,
    initFacebookPixelIfConsented
};
